<mat-toolbar>
  <img
    src="../assets/images/logo-derichebourg.png"
    alt="Derichebourg"
    aria-hidden="true"
    class="logo"
  />
  <span class="spacer"></span>

  <button
    mat-icon-button
    aria-label="Other applications icon"
    (click)="showCloseAppSelector($event)"
  >
    <mat-icon>apps</mat-icon>
  </button>
  <app-aplication-selector
    class="app-selector"
    appClickOutside
    *ngIf="showAppSelector"
    (clickedOutside)="closeAppSelector()"
    [(applicationName)]="applicationName"
  ></app-aplication-selector>

  <button
    mat-icon-button
    aria-label="User profile icon"
    (click)="showCloseUserProfile($event)"
  >
    <mat-icon>person</mat-icon>
  </button>
  <app-user-menu
    class="user-menu"
    appClickOutside
    *ngIf="showUserProfile"
    (clickedOutside)="closeUserProfile()"
  ></app-user-menu>
</mat-toolbar>

<main>
  <router-outlet></router-outlet>
</main>
